//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import StockControlMixin from './StockControlMixin.js'
import StockControlRecordGeneralInfo from './StockControlRecordGeneralInfo.vue'
import TableServer from '../../../../components/Table/Table.vue'
import TableCellObject from '../../../../components/Table/TableCellObject.vue'
import StockConfigurationDepartmentSelector from './StockConfigurationDepartmentSelector.vue'
import { Store, createFieldConfig } from '../../../../components/QSelectUtils.js'
import { formatDate } from '../../../../components/helpers.js'

export default {
  name: 'StockControl',
  components: {
    TableServer,
    TableCellObject,
    StockConfigurationDepartmentSelector,
    StockControlRecordGeneralInfo
  },
  mixins: [StockControlMixin],
  props: {
    stockControl: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      tools: [],
      store: null,

      departmentFieldConfig: createFieldConfig({ allRecordsFn: () => [] }),
      controlEmployeeFieldConfig: createFieldConfig({ allRecordsFn: () => [] }),
      controlEmployeePositionFieldConfig: createFieldConfig({ allRecordsFn: () => [] }),
      vehicleIssuanceFieldConfig: createFieldConfig({ allRecordsFn: () => [] }),

      autoUpdateTimeout: 300000,

      columns: this.prepareColumns([
        {
          name: 'toolName',
          label: 'Наименование номенклатурной позиции',
          labelTable: 'Наименование',
          sortable: true
        },
        // {
        //   name: 'unit',
        //   label: 'Единица измерения',
        //   labelTable: 'Единица</br>измерения',
        //   defaultWidth: 70,
        //   sortable: false
        // },
        // {
        //   name: 'amount',
        //   label: 'ПЛАН (Остаток по 1С)',
        //   labelTable: 'ПЛАН',
        //   defaultWidth: 70,
        //   sortable: false,
        //   format: formatAmount
        // },
        // {
        //   name: 'actualAmount',
        //   label: 'ФАКТ (Остаток фактический)',
        //   labelTable: 'ФАКТ',
        //   defaultWidth: 70,
        //   sortable: false,
        //   format: formatAmount
        // },
        {
          name: 'controlResultPresent',
          label: 'В наличии',
          labelTable: '',
          defaultWidth: 80,
          align: 'center',
          sortable: false
        },
        {
          name: 'controlResultAbsent',
          label: 'Отсутствует',
          labelTable: '',
          defaultWidth: 80,
          align: 'center',
          sortable: false
        }
      ]),
      loading: false
    }
  },
  computed: {
    stockControlRecord: function () {
      return this.stockControl && this.stockControl.stockControlRecord || null
    },
    hasEditAccess: function () {
      return !this.readonly && this.$d_hasOperation('stockAccessoryControl')
    }
  },
  watch: {
    stockControl: function (stockControl) {
      if (stockControl) {
        this.initToolsStore(stockControl.tools)
      }
    }
  },
  created: function () {
    if (this.stockControl) {
      this.initToolsStore(this.stockControl.tools)
    }
  },
  methods: {
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
      }
      return columns
    },

    // @Override
    getItems: function () {
      return this.tools
    },
    // @Override
    onUpdateRecord: function () {
      if (this.stockControl) {
        // TODO ?
      }
    },
    // @Override
    onRecordCreated: function (recordId) {
      // TODO обновить таблицу?
    },
    // @Override
    onDepartmentsChanged: function (recordId) {
      if (this.stockControl) {
        if (this.stockControl.department.id !== this.departmentSelectorConfig.departmentId) {
          this.$emit('reload-record', {
            stockId: this.stockControl.stock.id,
            depId: this.departmentSelectorConfig.departmentId,
            target: this
          })
        }
      }
    },

    initToolsStore: function (tools) {
      tools = tools || []
      tools = JSON.parse(JSON.stringify(tools))
      tools = tools.map(tool => this.itemMapper(tool))
      this.tools = tools

      if (this.store == null) {
        this.store = new Store({
          itemsFn: this.getItems,
          fullReadable: true,
          cached: false,
          searchable: false,
          searchFiltrationBySource: false,
          searchValueMinLength: 0
        })
      } else {
        this.$refs.table.onUpdate()
      }
    },

    onTableItemsUpdated: function (event) {
      this.updateAllItemsChecked(event.data)
    },
    getAdditionalUrlParams: function () {
      const params = {}
      params.stockId = this.stockId
      if (this.departmentSelectorConfig && this.departmentSelectorConfig.departmentId != null) {
        params.depId = this.departmentSelectorConfig.departmentId
      }
      if (this.stockControlRecordIdLocal != null) {
        params.stockControlRecordId = this.stockControlRecordIdLocal
      }
      return params
    },

    getTrClass: function (item) {
      return item.controlResultPresent ? 'stock-control__row-positive' : item.controlResultAbsent ? 'stock-control__row-negative' : ''
    },
    formatDate: formatDate
  }
}

